// extracted by mini-css-extract-plugin
module.exports = {"root":"YandexLogo-styles_root__1IKEq","image":"YandexLogo-styles_image__7Y2WF"};